import configLoader from './../configs//ConfigLoader';

export function Encrypt(text) {
    let result = '';
    let key = configLoader.get("CRYPT_KEY");
    if (text) {
        for (let i = 0; i < text.length; i++) {
            const char = text.charCodeAt(i);
            const keyChar = key.charCodeAt(i % 32);
            const encrypted = (char ^ keyChar) + (keyChar % 16);
            result += String.fromCharCode(encrypted % 256);
        }
    }
    return btoa(result);
}

export function Decrypt(encoded) {
    const text = atob(encoded);
    let result = '';
    let key = configLoader.get("CRYPT_KEY");
    if (text) {
        for (let i = 0; i < text.length; i++) {
            const char = text.charCodeAt(i);
            const keyChar = key.charCodeAt(i % 32);
            const decrypted = (char - (keyChar % 16)) ^ keyChar;
            result += String.fromCharCode(decrypted % 256);
        }
    }
    return result;
}
